import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';

export const DashboardLayout = (): JSX.Element => {
  return (
    <SidebarProvider defaultOpen={true}>
      <Sidebar />
      <SidebarInset>
        <SidebarTrigger className="fixed left-4 top-4 z-40 rounded-lg border bg-background shadow-md lg:hidden" />
        <main
          className="flex w-full flex-1 flex-col overflow-x-hidden overflow-y-auto p-4 lg:p-6"
          style={{ height: '100vh' }}
        >
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default DashboardLayout;
